
/** declare variable for Segment detail  */
export class SegmentDetails {
	/** id */
	id: string;
	/** investorId */
	investorId: string;
	/** isOpt */
	isOpt: string;
	/** segmentMasterDto */
	segmentMasterDto: ISegmentMaster;
	/** optsegments */
	optsegments: string;

	/** initial call */
	constructor() {
		this.segmentMasterDto = {  id: "", segmentName: "", segmentType: "" }
	}
}
/**
 * for storing Segment Name and Segment type
 */
export interface ISegmentMaster {
	/** id */
	id: string;
	/** segmentName */
	segmentName: string;
	/** segmentType */
	segmentType: string;
}